var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "filters__footer" },
    [
      _c("FiltersClear", {
        attrs: {
          clearFiltersText: _vm.clearFiltersText,
          clearAllFilters: _vm.clearAllFilters,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filters__buttons-wrapper" },
        [
          _c(
            "button",
            {
              staticClass: "button button-tertiary filters__hide-filters",
              on: { click: _vm.closeShowOptions },
            },
            [
              _vm._v("\n      Close filters\n      "),
              _c("span", { staticClass: "icon icon-cross-open" }),
            ]
          ),
          _vm._v(" "),
          _c("FiltersApplyButton", {
            staticClass: "filters__apply-button",
            attrs: {
              APICall: _vm.APICall,
              applyFiltersText: _vm.applyFiltersText,
              applyFiltersToAPICall: _vm.applyFiltersToAPICall,
              updateShowOptions: _vm.updateShowOptions,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }